import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getShowcasesList, getServiceShowcaseList, getshowcasData, getShowcasePlan, showcaseLike, GetFaq } from '../../Apis';
import { acceptAndRejectCounterOffer } from './proposalSlice';

export const GetCatShowcase = createAsyncThunk('get showcase based on cat', async ({ formData, token }, { rejectWithValue }) => {
    try {
        const response = await getShowcasesList(formData, token);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});
export const GetServiceShowcase = createAsyncThunk('GetServiceShowcase', async ({ formData, token }, { rejectWithValue }) => {
    try {
        const response = await getServiceShowcaseList(formData, token);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});


export const GetSingleShowcase = createAsyncThunk('GetSingleShowcase', async ({ formData, token }, { rejectWithValue }) => {
    try {
        const response = await getshowcasData(formData, token);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});

export const GetPlanShowcase = createAsyncThunk('GetPlanShowcase', async ({ formData, token }, { rejectWithValue }) => {
    try {
        const response = await getShowcasePlan(formData, token);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});

export const LikeShowcase = createAsyncThunk('LikeShowcase', async ({ formData, token }, { rejectWithValue }) => {
    try {
        const response = await showcaseLike(formData, token);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
})
// export const getFaq = createAsyncThunk("getFaq", async ({ token, formData }, { rejectWithValue }) => {
//     try {
//         const response = await GetFaq(token, formData);
//         return response;
//     } catch (error) {
//         return rejectWithValue(error.response)
//     }
// })

const showcaseClientSlice = createSlice({
    name: 'showcaseClient',
    initialState: {
        error: null,
        success: false,
        data: [],
        showSer: [],
        category: {},
        showcaseDat: {},
        planData: {},
        meta: [],
        error1: null,
        success1: false,
        faq: []
    },
    reducers: {
        clearShowClientStatus: state => {
            state.success = false;
            state.error = null;
            state.success1 = false;
            state.error1 = null;
        },

        clearvariables: state => {
            state.data = [];
            state.showSer = [];
            state.category = {};
            state.showcaseDat = {};
        },

    },
    extraReducers: builder => {
        builder
            .addCase(GetCatShowcase.pending, state => {
                state.error = null;
                state.success = false;
            })
            .addCase(GetCatShowcase.fulfilled, (state, action) => {
                state.success = action.payload;
                state.error = null;
                state.data = action.payload.data.data;
                state.category = action.payload.data.category;
                state.showSer = action.payload.data.service;
                state.meta = action.payload.data.slugCatMetas;
            })
            .addCase(GetCatShowcase.rejected, (state, action) => {
                state.error = action.payload;
                state.success = false;
            })
            .addCase(GetServiceShowcase.pending, state => {
                state.error = null;
                state.success = false;
            })
            .addCase(GetServiceShowcase.fulfilled, (state, action) => {
                state.success = action.payload;
                state.error = null;
                state.data = action.payload.data.data;
                state.category = action.payload.data.category;
            })
            .addCase(GetServiceShowcase.rejected, (state, action) => {
                state.error = action.payload;
                state.success = false;
            })
            .addCase(GetSingleShowcase.pending, state => {
                state.error = null;
                state.success = false;
            })
            .addCase(GetSingleShowcase.fulfilled, (state, action) => {
                state.success = action.payload;
                state.error = null;
                state.showcaseDat = action.payload.data.data;
            })
            .addCase(GetSingleShowcase.rejected, (state, action) => {
                state.error = action.payload;
                state.success = false;
            })
            .addCase(GetPlanShowcase.pending, state => {
                state.error1 = null;
                state.success1 = false;
            })
            .addCase(GetPlanShowcase.fulfilled, (state, action) => {
                state.success1 = action.payload;
                state.error1 = null;
                state.planData = action.payload.data.data;
            })
            .addCase(GetPlanShowcase.rejected, (state, action) => {
                state.error1 = action.payload;
                state.success1 = false;
            })
            .addCase(LikeShowcase.pending, state => {
                state.error1 = null;
                state.success1 = false;
            })
            .addCase(LikeShowcase.fulfilled, (state, action) => {
                state.success1 = action.payload;
                state.error1 = null;
            })
            .addCase(LikeShowcase.rejected, (state, action) => {
                state.error1 = action.payload;
                state.success1 = false;
            })
        // .addCase(getFaq.pending, state => (
        //     state.success = false,
        //     state.error = null
        // ))
        // .addCase(getFaq.fulfilled, (state, action) => {
        //     state.success = true;
        //     state.faq = action.payload.data.data;
        //     state.error = null
        // })
        // .addCase(getFaq.rejected, (state, action) => {
        //     state.error = action.payload;
        //     state.success = false
        // })

    },

});
export const { clearShowClientStatus, clearvariables } = showcaseClientSlice.actions;
export default showcaseClientSlice.reducer;

